import {
  IconApps,
  IconBrandPagekit,
  IconBuildingStore,
  IconCalendarEvent,
  IconCreditCard,
  IconDatabase,
  IconMail,
  IconNotebook,
  IconSwords,
  IconTournament,
  IconTrophy,
  IconUserCircle,
  IconUserShield,
  IconStar,
} from "@tabler/icons-react";
import {
  HeaderLink,
  ServiceLinkItem,
} from "./components/app-shell/header/Header";

export const ServiceItems: ServiceLinkItem[] = [
  {
    icon: IconTournament,
    title: "Tournaments",
    description: "Create brackets, manage teams and run competitive events",
    path: "/tournaments",
    color: "purple",
  },
  {
    icon: IconCalendarEvent,
    title: "Events",
    description: "Ticketing, reservations and venue management",
    path: "/events",
    color: "amber",
  },
  {
    icon: IconSwords,
    title: "Players",
    description: "Player profiles, identity providers and skill ratings",
    path: "/players",
    color: "cyan",
  },
  {
    icon: IconTrophy,
    title: "Leaderboards",
    description: "Ranked leaderboards with seasons and buckets",
    path: "/leaderboards",
    color: "green",
  },
  {
    icon: IconStar,
    title: "Gamification",
    description: "Items, currencies, shops and player rewards",
    path: "/gamification",
    color: "amber",
  },
  {
    icon: IconBrandPagekit,
    title: "Platform",
    description: "Build and deploy user-facing pages and content",
    path: "/platform",
    color: "cyan",
  },
  {
    icon: IconMail,
    title: "Emails",
    description: "Email templates and transactional email config",
    path: "/emails",
    color: "rose",
  },
  {
    icon: IconUserCircle,
    title: "Organizations",
    description: "Manage your organizations and settings",
    path: "/organizations",
    color: "dark",
  },
  {
    icon: IconUserShield,
    title: "IAM",
    description: "Groups, members and application access control",
    path: "/iam",
    color: "dark",
  },
  {
    icon: IconApps,
    title: "Developer",
    description: "Apps, Webhooks & Marketplace management",
    path: "/developer",
    color: "dark",
  },
  {
    icon: IconCreditCard,
    title: "Subscription",
    description: "Plans, limits and seller settings",
    path: "/limits",
    color: "dark",
  },
  {
    icon: IconDatabase,
    title: "Data",
    description: "Custom fields & metadata management",
    path: "/data",
    color: "cyan",
  },
  {
    icon: IconBuildingStore,
    title: "Marketplace",
    description: "Browse and manage app extensions",
    path: "/marketplace",
    color: "green",
  },
  {
    icon: IconNotebook,
    title: "Journal",
    description: "Browse runtime events, audit logs, and rule executions",
    path: "/journal",
    color: "purple",
  },
];

const sortedServiceItems: ServiceLinkItem[] = [...ServiceItems].sort((a, b) =>
  a.title.localeCompare(b.title),
);

export const ServiceLinks: HeaderLink[] = [
  {
    title: "Dashboard",
    path: "/",
  },
  {
    title: "Services",
    children: sortedServiceItems,
  },
];
